import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { TitleScene } from './scenes/TitleScene';
import { GameScene } from './scenes/GameScene';
import { ResultScene } from './scenes/ResultScene';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: 720,
  height: 1280,
  parent: 'game-container',
  backgroundColor: '#799EFF',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: 720,
    height: 1280,
  },
  scene: [BootScene, TitleScene, GameScene, ResultScene],
  physics: {
    default: 'matter',
    matter: {
      gravity: { y: 1.0, x: 0 }, // 重力（下向き、軽めに設定して滞空時間を伸ばす）
      debug: false, // デバッグモード：コライダーを可視化
    },
  },
};

const game = new Phaser.Game(config);

// Canvasの中央配置を強制する関数
const centerCanvas = () => {
  const canvas = document.querySelector('#game-container > canvas') as HTMLCanvasElement;
  if (canvas) {
    // CSSの!importantをJavaScriptで設定するには、setPropertyの第3引数に'important'を指定
    canvas.style.setProperty('position', 'absolute', 'important');
    canvas.style.setProperty('left', '50%', 'important');
    canvas.style.setProperty('top', '50%', 'important');
    canvas.style.setProperty('transform', 'translate(-50%, -50%)', 'important');
    canvas.style.setProperty('margin', '0', 'important');
    canvas.style.setProperty('display', 'block', 'important');
  }
};

// ゲーム起動後にCanvasを中央配置
game.events.once('ready', () => {
  centerCanvas();
});

// MutationObserverでCanvasのスタイル変更を監視し、中央配置を維持
const observer = new MutationObserver(() => {
  centerCanvas();
});

// Canvasが作成されたら監視を開始
const checkCanvas = setInterval(() => {
  const canvas = document.querySelector('#game-container > canvas');
  if (canvas) {
    observer.observe(canvas, {
      attributes: true,
      attributeFilter: ['style'],
    });
    centerCanvas();
    clearInterval(checkCanvas);
  }
}, 100);

// レスポンシブ対応: リサイズ処理関数
const handleResize = () => {
  if (game && game.scale) {
    game.scale.refresh();
    // リサイズ後も中央配置を維持
    setTimeout(centerCanvas, 100);
  }
};

// ウィンドウリサイズ時の処理
window.addEventListener('resize', handleResize);

// モバイルデバイスの向き変更時の処理
window.addEventListener('orientationchange', () => {
  setTimeout(handleResize, 100);
});

// ビューポートの変更を検知（モバイルのアドレスバー表示/非表示など）
if (window.visualViewport) {
  window.visualViewport.addEventListener('resize', handleResize);
}

export default game;
